import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable, map } from 'rxjs';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { environment } from 'src/assets/environments/environment.prod';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class CompletedFilesService {
  constructor(
    private http: HttpClient,
    private appSettingsService: AppSettingsService
  ) {}

  getCompletedFiles(queryParams: any): Observable<any> {
    let params = this.appSettingsService.queryStrFormat(queryParams);

    return this.http
      .get('attachment/submittedForms?' + params, httpOptions)
      .pipe(
        map((resp: any) => {
          let retData: any = {
            items: [],
            totalCount: 0,
            error: ''
          };

          if (
            resp &&
            resp.data &&
            Array.isArray(resp.data.rows) &&
            resp?.error?.code <= 0
          ) {
            let rows = resp.data.rows;
            for (const item of rows) {
              let pdfUrl =
                environment.mediaUrl + item?.dir + '/' + item?.fileName;
              let formName: string;
              if (item.class == 'AgreementByCompany') {
                formName = item.originalFileName || 'License Agreement';
              } else {
                formName = item.originalFileName || 'Form';
              }
              let temp: any = {
                ...item,
                ...item.createdBy,
                ...item.createdBy?.companyDetails,
                id: item.id,
                fileName: formName,
                file: pdfUrl,
                createdAt: moment(item?.createdAt).format('YYYY MMMM DD'),
                updatedAt: moment(item?.updatedAt).format('YYYY MMMM DD')
              };
              retData.items.push(temp);
            }

            retData.totalCount = resp.data.count;
          } else {
            retData.error = resp?.error?.message ? resp.error.message : '';
          }

          return retData;
        })
      );
  }

  //handle error messages
  handleError(err: any) {
    this.appSettingsService.handleError(err);
  }
}
